export const Maps = () => {
  return (
    <section className="w-full">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d879.1389450581926!2d83.96634626963478!3d28.190422180520642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDExJzI1LjUiTiA4M8KwNTgnMDEuMiJF!5e0!3m2!1sen!2snp!4v1732255348944!5m2!1sen!2snp"
        width="600"
        height="450"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="h-[400px] w-full md:h-[473px] lg:max-h-[727px]"
      ></iframe>
    </section>
  )
}
